import React from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './style.css';
// import {initaldata} from '../../components/common/ProductCards/SliderData';
export const initaldata = [
  {id: 1, active: true, image: '/assets/ChargesIcons/DeliveryIcon.png', title: 'Delivery charge', use: 'For BSE & NSE Stock Brokers',},
  {id: 2, active: true, image: '/assets/ChargesIcons/GSTIcon.png', title: 'GST', use: 'For CDSL DPs',},
  {id: 3, active: true, image: '/assets/ChargesIcons/Stt.png', title: 'STT', use: 'For NDSL DPs',},
  {id: 4, active: true, image: '/assets/ChargesIcons/TurnoverCharges.png', title: 'Turnover Charges', use: 'For MCX & NCDEX commodities',},
  {id: 5, active: false, image: '/assets/ChargesIcons/StampDuty.png', title: 'Stamp Duty', use: 'Back Office Data Access Utility',},
  {id: 6, active: false, image: '/assets/ChargesIcons/DematIcon.png', title: 'Demat Delivery charge', use: 'For MCX & NCDEX commodities',},
  {id: 7, active: false, image: '/assets/ChargesIcons/TurnoverCharges.png', title: 'Any other charge that may be based on turnover, brokerage etc.', use: 'For MCX & NCDEX commodities',},
  {id: 8, active: false, image: '/assets/img/Facility-14.svg', title: 'Facility to levy service tax on charges.', use: 'For MCX & NCDEX commodities',},

 ];

 const BackArrow = (props) => {
	return (
	  <button type="button" onClick={props.onClick} className="trade-plus-btn-left back-forword-btn bg-white -m-8 absolute z-50	 ext-blue-700 border border-blue-700 hover:bg-[#3491FF] hover:text-white  focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:focus:ring-blue-800">
		<svg className="stroke-[#3491ff] hover:stroke-[#ffffff]  " width="25" height="25" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		  <path d="M13.168 3.56969L7.46297 9.27469C6.78922 9.94844 6.78922 11.0509 7.46297 11.7247L13.168 17.4297" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
		</svg>
	  </button>
	)
  }
  
  const ForwardArrow = (props) => {
	return (
    <button type="button" onClick={props.onClick} className="trade-plus-btn-right back-forword-btn bg-white -m-8 absolute z-50	 ext-blue-700 border border-blue-700 hover:bg-[#3491FF] hover:text-white  focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:focus:ring-blue-800">
		<svg className="stroke-[#3491ff] hover:stroke-[#ffffff]" width="25" height="25" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		  <path d="M7.83203 3.56969L13.537 9.27469C14.2108 9.94844 14.2108 11.0509 13.537 11.7247L7.83203 17.4297" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
		</svg>
	  </button>
	)
  }

const Facility = ()=>{

    const  settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    initialSlide: 0,
    nextArrow: <ForwardArrow />,
		prevArrow: <BackArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  };
  return (
      <>
          <div className="bg-[#F4FAFF]">
          <div className='title-box text-center px-2 py-6'>
                  <h2 className='title text-lg lg:text-2xl font-bold sm:text-3xl md:text-3xl pt-8 pb-4 text-[#0A2A4A]'>Charges</h2>
                  <div className="lg:text-[18px] md:text-[16px] text-[14px] leading-relaxed font-medium mx-auto text-[#808D9A]">Various charges that may be levied over and above brokerage and may be specifically shown in contract / Bill.</div>
              </div>
              <div className="container flex flex-wrap justify-between items-center mx-auto mb-0 px-0 pb-6">
                  <Slider {...settings} >
                      {initaldata.map((value, index) => (
                          <div
                          key={index + '_value'}
                          className=" flex justify-center lg:w-40 lg:h-[12rem] md:w-40 md:h-40 w-40 h-[11rem] bg-[#FFFFFF] p-5 md:bg-[#FFFFFF] items-center drop-shadow-md rounded-xl"
                      >
                          <div className="items-center justify-self-center">
                              <img alt="No Image" src={value.image} className="h-10 w-10 lg:h-20 lg:w-20 md:w-20 md:h-20 mb-3 place-content-between block absolute top-12 left-1/2 -translate-x-1/2 -translate-y-1/2" />
                              <h2 className="text-center lg:text-[18px] md:text-[18px] text-[16px] h-[5rem] overflow-auto scrollbar-hide title-font   lg:mt-20 md:mt-20 mt-[4rem] font-semi-bold text-[#0A2A4A]">{value.title}</h2>    
                          </div>
                      </div>
                      ))}
                  </Slider>
              </div>
          </div>
      </>
  )
}
export default Facility;